/**
 * Route for `position-based-attribution`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { PositionBasedAttributionPage } from "../features/position-based-attribution/PositionBasedAttributionPage";

export const positionBasedAttributionRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/position-based-attribution",
	component: PositionBasedAttributionPage,
});

export default positionBasedAttributionRoute;
